import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router'

/* the window keeps its offset across routes otherwise. keyed on the path, so a
 * list writing its page or filters into the query string doesn't jump. */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, [])

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
